// extracted by mini-css-extract-plugin
export var orderSummary = "_tv-0";
export var showMoreLessButton = "_tv-1";